import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { richTextFilter } from '../Utilities/Rich-text-filter'

function filterText(data) {
  let returnText = ""
  data.map(function(node, index) {
    if(node.body) {
      returnText = <div dangerouslySetInnerHTML={{ __html: richTextFilter(node.body.value) }} />
    }
    return true;

  })
  return (returnText)
}

const FooterMenuColTwo = () => (
  <StaticQuery

    query={graphql`
      query {
        content: allBlockContentBasic(filter: {drupal_internal__id: {eq: 2}}) {
          nodes {
            drupal_internal__id
            body {
              value
            }
          }
        }
      }
    `}

    render={data => (
      <>
        {filterText(data.content.nodes)}
      </>
    )}
  />

)

export default FooterMenuColTwo

